<template>
  <div class="svgContaines">
    <svg width="auto" viewBox="0 0 1226 1598" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="csu_arvore">
        <!-- =================== BLOCOS ===================== -->
        <rect
          id="pergunta_3"
          x="63"
          y="349"
          width="500"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[3]?.toString()"
        />
        <rect
          id="pergunta_4"
          x="63"
          y="649"
          width="200"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[4]?.toString()"
        />
        <rect
          id="pergunta_5"
          x="363"
          y="649"
          width="200"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[5]?.toString()"
        />
        <rect
          id="pergunta_6"
          x="213"
          y="949"
          width="200"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[6]?.toString()"
        />

        <rect
          id="pergunta_7"
          x="513"
          y="949"
          width="200"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[7]?.toString()"
        />
        <rect
          id="pergunta_8"
          x="513"
          y="1249"
          width="200"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[8]?.toString()"
        />
        <rect
          id="pergunta_10"
          x="663"
          y="649"
          width="200"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[10]?.toString()"
        />
        <rect
          id="pergunta_11"
          x="963"
          y="649"
          width="200"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[11]?.toString()"
        />
        <rect
          id="pergunta_9"
          x="663"
          y="349"
          width="500"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[9]?.toString()"
        />
        <rect
          id="pergunta_1"
          x="63"
          y="49"
          width="500"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[1]?.toString()"
        />
        <rect
          id="pergunta_2"
          x="663"
          y="49"
          width="500"
          height="200"
          rx="20"
          fill="#D9D9D900"
          :class="fluxNumbers[2]?.toString()"
        />

        <!-- =================== LINHAS ===================== -->
        <path
          id="seta_pergunta_1_sim"
          d="M311.586 350.414C312.367 351.195 313.633 351.195 314.414 350.414L327.142 337.686C327.923 336.905 327.923 335.639 327.142 334.858C326.361 334.077 325.095 334.077 324.314 334.858L313 346.172L301.686 334.858C300.905 334.077 299.639 334.077 298.858 334.858C298.077 335.639 298.077 336.905 298.858 337.686L311.586 350.414ZM311 249L311 349L315 349L315 249L311 249Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[1],
          }"
        />
        <path
          id="seta_pergunta_3"
          d="M314.414 547.586C313.633 546.805 312.367 546.805 311.586 547.586L298.858 560.314C298.077 561.095 298.077 562.361 298.858 563.142C299.639 563.923 300.905 563.923 301.686 563.142L313 551.828L324.314 563.142C325.095 563.923 326.361 563.923 327.142 563.142C327.923 562.361 327.923 561.095 327.142 560.314L314.414 547.586ZM315 599L315 549L311 549L311 599L315 599Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[3] || fluxNumbers[3] === false,
          }"
        />
        <path
          id="seta_pergunta_3_nao"
          d="M461.586 650.414C462.367 651.195 463.633 651.195 464.414 650.414L477.142 637.686C477.923 636.905 477.923 635.639 477.142 634.858C476.361 634.077 475.095 634.077 474.314 634.858L463 646.172L451.686 634.858C450.905 634.077 449.639 634.077 448.858 634.858C448.077 635.639 448.077 636.905 448.858 637.686L461.586 650.414ZM461 599L461 649L465 649L465 599L461 599Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[3] === false,
          }"
        />
        <path
          id="seta_pergunta_3_sim"
          d="M161.586 650.414C162.367 651.195 163.633 651.195 164.414 650.414L177.142 637.686C177.923 636.905 177.923 635.639 177.142 634.858C176.361 634.077 175.095 634.077 174.314 634.858L163 646.172L151.686 634.858C150.905 634.077 149.639 634.077 148.858 634.858C148.077 635.639 148.077 636.905 148.858 637.686L161.586 650.414ZM161 599L161 649L165 649L165 599L161 599Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[3],
          }"
        />
        <path
          id="seta_pergunta_4_sim"
          d="M161.586 1550.41C162.367 1551.2 163.633 1551.2 164.414 1550.41L177.142
        1537.69C177.923 1536.91 177.923 1535.64 177.142 1534.86C176.361 1534.08 175.095 1534.08 174.314 1534.86L163
        1546.17L151.686 1534.86C150.905 1534.08 149.639 1534.08 148.858 1534.86C148.077 1535.64 148.077 1536.91 148.858
        1537.69L161.586 1550.41ZM161 849L161 1549L165 1549L165 849L161 849Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[4],
          }"
        />
        <path
          id="seta_pergunta_6_sim"
          d="M310.586 1550.41C311.367 1551.2 312.633 1551.2 313.414 1550.41L326.142 1537.69C326.923 1536.91 326.923 1535.64 326.142 1534.86C325.361 1534.08 324.095 1534.08 323.314 1534.86L312 1546.17L300.686 1534.86C299.905 1534.08 298.639 1534.08 297.858 1534.86C297.077 1535.64 297.077 1536.91 297.858 1537.69L310.586 1550.41ZM310 1149L310 1549L314 1549L314 1149L310 1149Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[6],
          }"
        />
        <path
          id="seta_pergunta_8_sim"
          d="M611.586 1550.41C612.367 1551.2 613.633 1551.2 614.414 1550.41L627.142 1537.69C627.923 1536.91 627.923 1535.64 627.142 1534.86C626.361 1534.08 625.095 1534.08 624.314 1534.86L613 1546.17L601.686 1534.86C600.905 1534.08 599.639 1534.08 598.858 1534.86C598.077 1535.64 598.077 1536.91 598.858 1537.69L611.586 1550.41ZM611 1449L611 1549L615 1549L615 1449L611 1449Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[8],
          }"
        />
        <path
          id="linha_pergunta_3_nao"
          d="M312 599C321.23 599 417.681 599 464 599"
          stroke="#D9D9D9"
          stroke-width="4"
          :class="{
            line: true,
            selected: fluxNumbers[3] === false,
          }"
        />
        <path
          id="linha_pergunta_3_sim"
          d="M313 599C266.986 599 171.17 599 162 599L161.5 599"
          stroke="#D9D9D9"
          stroke-width="4"
          :class="{
            line: true,
            selected: fluxNumbers[8] === false,
          }"
        />
        <path
          id="seta_pergunta_9"
          d="M917.914 547.586C917.133 546.805 915.867 546.805 915.086 547.586L902.358 560.314C901.577 561.095 901.577 562.361 902.358 563.142C903.139 563.923 904.405 563.923 905.186 563.142L916.5 551.828L927.814 563.142C928.595 563.923 929.861 563.923 930.642 563.142C931.423 562.361 931.423 561.095 930.642 560.314L917.914 547.586ZM918.5 599L918.5 549L914.5 549L914.5 599L918.5 599Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[9] || fluxNumbers[9] === false,
          }"
        />
        <path
          id="seta_pergunta_9_sim"
          d="M1065.09 650.414C1065.87 651.195 1067.13 651.195 1067.91 650.414L1080.64 637.686C1081.42 636.905 1081.42 635.639 1080.64 634.858C1079.86 634.077 1078.59 634.077 1077.81 634.858L1066.5 646.172L1055.19 634.858C1054.41 634.077 1053.14 634.077 1052.36 634.858C1051.58 635.639 1051.58 636.905 1052.36 637.686L1065.09 650.414ZM1064.5 599L1064.5 649L1068.5 649L1068.5 599L1064.5 599Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[9],
          }"
        />
        <path
          id="seta_pergunta_9_nao"
          d="M765.086 650.414C765.867 651.195 767.133 651.195 767.914 650.414L780.642 637.686C781.423 636.905 781.423 635.639 780.642 634.858C779.861 634.077 778.595 634.077 777.814 634.858L766.5 646.172L755.186 634.858C754.405 634.077 753.139 634.077 752.358 634.858C751.577 635.639 751.577 636.905 752.358 637.686L765.086 650.414ZM764.5 599L764.5 649L768.5 649L768.5 599L764.5 599Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[9] === false,
          }"
        />
        <path
          id="linha_pergunta_9_sim"
          d="M915.5 599C924.73 599 1021.18 599 1067.5 599"
          stroke="#D9D9D9"
          stroke-width="4"
          :class="{
            line: true,
            selected: fluxNumbers[9],
          }"
        />
        <path
          id="linha_pergunta_9_nao"
          d="M916.5 599C870.486 599 774.67 599 765.5 599L765 599"
          stroke="#D9D9D9"
          stroke-width="4"
          :class="{
            line: true,
            selected: fluxNumbers[9] === false,
          }"
        />
        <path
          id="seta_pergunta_5"
          d="M465.914 847.586C465.133 846.805 463.867 846.805 463.086 847.586L450.358 860.314C449.577 861.095 449.577 862.361 450.358 863.142C451.139 863.923 452.405 863.923 453.186 863.142L464.5 851.828L475.814 863.142C476.595 863.923 477.861 863.923 478.642 863.142C479.423 862.361 479.423 861.095 478.642 860.314L465.914 847.586ZM466.5 899L466.5 849L462.5 849L462.5 899L466.5 899Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[5] || fluxNumbers[5] === false,
          }"
        />
        <path
          id="seta_pergunta_10_nao"
          d="M613.086 950.414C613.867 951.195 615.133 951.195 615.914 950.414L628.642 937.686C629.423 936.905 629.423 935.639 628.642 934.858C627.861 934.077 626.595 934.077 625.814 934.858L614.5 946.172L603.186 934.858C602.405 934.077 601.139 934.077 600.358 934.858C599.577 935.639 599.577 936.905 600.358 937.686L613.086 950.414ZM612.5 899L612.5 949L616.5 949L616.5 899L612.5 899Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[10] === false,
          }"
        />
        <path
          id="seta_pergunta_5_sim"
          d="M313.086 950.414C313.867 951.195 315.133 951.195 315.914 950.414L328.642 937.686C329.423 936.905 329.423 935.639 328.642 934.858C327.861 934.077 326.595 934.077 325.814 934.858L314.5 946.172L303.186 934.858C302.405 934.077 301.139 934.077 300.358 934.858C299.577 935.639 299.577 936.905 300.358 937.686L313.086 950.414ZM312.5 899L312.5 949L316.5 949L316.5 899L312.5 899Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[5],
          }"
        />
        <path
          id="seta_pergunta_4_nao"
          d="M364.414 750.414C365.195 749.633 365.195 748.367 364.414 747.586L351.686 734.858C350.905 734.077 349.639 734.077 348.858 734.858C348.077 735.639 348.077 736.905 348.858 737.686L360.172 749L348.858 760.314C348.077 761.095 348.077 762.361 348.858 763.142C349.639 763.923 350.905 763.923 351.686 763.142L364.414 750.414ZM263 751H363V747H263V751Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[4] === false,
          }"
        />
        <path
          id="seta_pergunta_11_nao"
          d="M861.586 747.586C860.805 748.367 860.805 749.633 861.586 750.414L874.314 763.142C875.095 763.923 876.361 763.923 877.142 763.142C877.923 762.361 877.923 761.095 877.142 760.314L865.828 749L877.142 737.686C877.923 736.905 877.923 735.639 877.142 734.858C876.361 734.077 875.095 734.077 874.314 734.858L861.586 747.586ZM863 751H963V747H863V751Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[11] === false,
          }"
        />
        <path
          id="seta_pergunta_6_nao"
          d="M514.414 1050.41C515.195 1049.63 515.195 1048.37 514.414 1047.59L501.686 1034.86C500.905 1034.08 499.639 1034.08 498.858 1034.86C498.077 1035.64 498.077 1036.91 498.858 1037.69L510.172 1049L498.858 1060.31C498.077 1061.09 498.077 1062.36 498.858 1063.14C499.639 1063.92 500.905 1063.92 501.686 1063.14L514.414 1050.41ZM413 1051H513V1047H413V1051Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[6] === false,
          }"
        />
        <path
          id="linha_pergunta_5_nao"
          d="M463.5 899C472.73 899 569.181 899 615.5 899"
          stroke="#D9D9D9"
          stroke-width="4"
          :class="{
            line: true,
            selected: fluxNumbers[5] === false,
          }"
        />
        <path
          id="linha_pergunta_5_sim"
          d="M464.5 899C418.486 899 322.67 899 313.5 899L313 899"
          stroke="#D9D9D9"
          stroke-width="4"
          :class="{
            line: true,
            selected: fluxNumbers[5],
          }"
        />
        <path
          id="seta_pergunta_10"
          d="M764.914 847.586C764.133 846.805 762.867 846.805 762.086 847.586L749.358 860.314C748.577 861.095 748.577 862.361 749.358 863.142C750.139 863.923 751.405 863.923 752.186 863.142L763.5 851.828L774.814 863.142C775.595 863.923 776.861 863.923 777.642 863.142C778.423 862.361 778.423 861.095 777.642 860.314L764.914 847.586ZM765.5 899L765.5 849L761.5 849L761.5 899L765.5 899Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[10] || fluxNumbers[10] === false,
          }"
        />
        <path
          id="seta_pergunta_10_sim"
          d="M912.586 1550.41C913.367 1551.2 914.633 1551.2 915.414 1550.41L928.142 1537.69C928.923 1536.91 928.923 1535.64 928.142 1534.86C927.361 1534.08 926.095 1534.08 925.314 1534.86L914 1546.17L902.686 1534.86C901.905 1534.08 900.639 1534.08 899.858 1534.86C899.077 1535.64 899.077 1536.91 899.858 1537.69L912.586 1550.41ZM912 899L912 1549L916 1549L916 899L912 899Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[10],
          }"
        />
        <path
          id="seta_pergunta_11_sim"
          d="M1061.59 1550.41C1062.37 1551.2 1063.63 1551.2 1064.41 1550.41L1077.14 1537.69C1077.92 1536.91 1077.92 1535.64 1077.14 1534.86C1076.36 1534.08 1075.09 1534.08 1074.31 1534.86L1063 1546.17L1051.69 1534.86C1050.91 1534.08 1049.64 1534.08 1048.86 1534.86C1048.08 1535.64 1048.08 1536.91 1048.86 1537.69L1061.59 1550.41ZM1061 849L1061 1549L1065 1549L1065 849L1061 849Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[11],
          }"
        />
        <path
          id="seta_pergunta_5_nao"
          d="M612.086 950.414C612.867 951.195 614.133 951.195 614.914 950.414L627.642 937.686C628.423 936.905 628.423 935.639 627.642 934.858C626.861 934.077 625.595 934.077 624.814 934.858L613.5 946.172L602.186 934.858C601.405 934.077 600.139 934.077 599.358 934.858C598.577 935.639 598.577 936.905 599.358 937.686L612.086 950.414ZM611.5 899L611.5 949L615.5 949L615.5 899L611.5 899Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[5] === false,
          }"
        />
        <path
          id="linha_pergunta_10_sim"
          d="M762.5 899C771.73 899 868.181 899 914.5 899"
          stroke="#D9D9D9"
          stroke-width="4"
          :class="{
            line: true,
            selected: fluxNumbers[10],
          }"
        />
        <path
          id="linha_pergunta_10_nao"
          d="M763.5 899C717.486 899 621.67 899 612.5 899L612 899"
          stroke="#D9D9D9"
          stroke-width="4"
          :class="{
            line: true,
            selected: fluxNumbers[10] === false,
          }"
        />
        <path
          id="seta_pergunta_7_sim"
          d="M614.586 1248.41C615.367 1249.2 616.633 1249.2 617.414 1248.41L630.142 1235.69C630.923 1234.91 630.923 1233.64 630.142 1232.86C629.361 1232.08 628.095 1232.08 627.314 1232.86L616 1244.17L604.686 1232.86C603.905 1232.08 602.639 1232.08 601.858 1232.86C601.077 1233.64 601.077 1234.91 601.858 1235.69L614.586 1248.41ZM614 1149L614 1247L618 1247L618 1149L614 1149Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[7],
          }"
        />
        <path
          id="seta_pergunta_7_nao"
          d="M464.586 1550.41C465.367 1551.2 466.633 1551.2 467.414 1550.41L480.142 1537.69C480.923 1536.91 480.923 1535.64 480.142 1534.86C479.361 1534.08 478.095 1534.08 477.314 1534.86L466 1546.17L454.686 1534.86C453.905 1534.08 452.639 1534.08 451.858 1534.86C451.077 1535.64 451.077 1536.91 451.858 1537.69L464.586 1550.41ZM464 1198L464 1549L468 1549L468 1198L464 1198Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[7] === false,
          }"
        />
        <path
          id="seta_pergunta_8_nao"
          d="M763.586 1550.41C764.367 1551.2 765.633 1551.2 766.414 1550.41L779.142 1537.69C779.923 1536.91 779.923 1535.64 779.142 1534.86C778.361 1534.08 777.095 1534.08 776.314 1534.86L765 1546.17L753.686 1534.86C752.905 1534.08 751.639 1534.08 750.858 1534.86C750.077 1535.64 750.077 1536.91 750.858 1537.69L763.586 1550.41ZM763 1349L763 1549L767 1549L767 1349L763 1349Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[8] === false,
          }"
        />
        <path
          id="linha_pergunta_7_nao"
          d="M616 1199C569.834 1199 473.702 1199 464.502 1199L464 1199"
          stroke="#D9D9D9"
          stroke-width="4"
          :class="{
            line: true,
            selected: fluxNumbers[7] === false,
          }"
        />
        <path
          id="linha_pergunta_8_nao"
          d="M767 1349C750.599 1349 716.447 1349 713.178 1349L713 1349"
          stroke="#D9D9D9"
          stroke-width="4"
          :class="{
            line: true,
            selected: fluxNumbers[8] === false,
          }"
        />
        <path
          id="seta_pergunta_2_sim"
          d="M911.586 350.414C912.367 351.195 913.633 351.195 914.414 350.414L927.142 337.686C927.923 336.905 927.923 335.639 927.142 334.858C926.361 334.077 925.095 334.077 924.314 334.858L913 346.172L901.686 334.858C900.905 334.077 899.639 334.077 898.858 334.858C898.077 335.639 898.077 336.905 898.858 337.686L911.586 350.414ZM911 249L911 349L915 349L915 249L911 249Z"
          fill="#D9D9D900"
          :class="{
            line: true,
            selected: fluxNumbers[2],
          }"
        />

        <!-- =================== TEXTO ===================== -->
        <path
          id="1"
          d="M320.477 121.812V179H313.25V130.836L298.68 136.148V129.625L319.344 121.812H320.477Z"
          :class="{
            line: true,
            selected: fluxNumbers[1] || fluxNumbers[1] === false,
          }"
        />
        <path
          id="3"
          d="M307.273 444.008H312.43C314.956 444.008 317.039 443.591 318.68 442.758C320.346 441.898 321.583 440.74 322.391 439.281C323.224 437.797 323.641 436.13 323.641 434.281C323.641 432.094 323.276 430.258 322.547 428.773C321.818 427.289 320.724 426.169 319.266 425.414C317.807 424.659 315.958 424.281 313.719 424.281C311.688 424.281 309.891 424.685 308.328 425.492C306.792 426.273 305.581 427.393 304.695 428.852C303.836 430.31 303.406 432.029 303.406 434.008H296.18C296.18 431.117 296.909 428.487 298.367 426.117C299.826 423.747 301.87 421.859 304.5 420.453C307.156 419.047 310.229 418.344 313.719 418.344C317.156 418.344 320.164 418.956 322.742 420.18C325.32 421.378 327.326 423.174 328.758 425.57C330.19 427.94 330.906 430.896 330.906 434.438C330.906 435.87 330.568 437.406 329.891 439.047C329.24 440.661 328.211 442.172 326.805 443.578C325.424 444.984 323.628 446.143 321.414 447.055C319.201 447.94 316.544 448.383 313.445 448.383H307.273V444.008ZM307.273 449.945V445.609H313.445C317.065 445.609 320.06 446.039 322.43 446.898C324.799 447.758 326.661 448.904 328.016 450.336C329.396 451.768 330.359 453.344 330.906 455.062C331.479 456.755 331.766 458.448 331.766 460.141C331.766 462.797 331.31 465.154 330.398 467.211C329.513 469.268 328.25 471.013 326.609 472.445C324.995 473.878 323.094 474.958 320.906 475.688C318.719 476.417 316.336 476.781 313.758 476.781C311.284 476.781 308.953 476.43 306.766 475.727C304.604 475.023 302.69 474.008 301.023 472.68C299.357 471.326 298.055 469.672 297.117 467.719C296.18 465.74 295.711 463.487 295.711 460.961H302.938C302.938 462.94 303.367 464.672 304.227 466.156C305.112 467.641 306.362 468.799 307.977 469.633C309.617 470.44 311.544 470.844 313.758 470.844C315.971 470.844 317.872 470.466 319.461 469.711C321.076 468.93 322.312 467.758 323.172 466.195C324.057 464.633 324.5 462.667 324.5 460.297C324.5 457.927 324.005 455.987 323.016 454.477C322.026 452.94 320.62 451.807 318.797 451.078C317 450.323 314.878 449.945 312.43 449.945H307.273Z"
          :class="{
            line: true,
            selected: fluxNumbers[3] || fluxNumbers[3] === false,
          }"
        />
        <path
          id="4"
          d="M182.164 756.859V762.797H141.07V758.539L166.539 719.125H172.438L166.109 730.531L149.273 756.859H182.164ZM174.234 719.125V776H167.008V719.125H174.234Z"
          :class="{
            line: true,
            selected: fluxNumbers[4] || fluxNumbers[4] === false,
          }"
        />
        <path
          id="5"
          d="M452.867 748.93L447.086 747.445L449.938 719.125H479.117V725.805H456.07L454.352 741.273C455.393 740.674 456.708 740.115 458.297 739.594C459.911 739.073 461.76 738.812 463.844 738.812C466.474 738.812 468.831 739.268 470.914 740.18C472.997 741.065 474.768 742.341 476.227 744.008C477.711 745.674 478.844 747.68 479.625 750.023C480.406 752.367 480.797 754.984 480.797 757.875C480.797 760.609 480.419 763.122 479.664 765.414C478.935 767.706 477.828 769.711 476.344 771.43C474.859 773.122 472.984 774.438 470.719 775.375C468.479 776.312 465.836 776.781 462.789 776.781C460.497 776.781 458.323 776.469 456.266 775.844C454.234 775.193 452.411 774.216 450.797 772.914C449.208 771.586 447.906 769.945 446.891 767.992C445.901 766.013 445.276 763.695 445.016 761.039H451.891C452.203 763.174 452.828 764.971 453.766 766.43C454.703 767.888 455.927 768.995 457.438 769.75C458.974 770.479 460.758 770.844 462.789 770.844C464.508 770.844 466.031 770.544 467.359 769.945C468.688 769.346 469.807 768.487 470.719 767.367C471.63 766.247 472.32 764.893 472.789 763.305C473.284 761.716 473.531 759.932 473.531 757.953C473.531 756.156 473.284 754.49 472.789 752.953C472.294 751.417 471.552 750.076 470.562 748.93C469.599 747.784 468.414 746.898 467.008 746.273C465.602 745.622 463.987 745.297 462.164 745.297C459.742 745.297 457.906 745.622 456.656 746.273C455.432 746.924 454.169 747.81 452.867 748.93Z"
          :class="{
            line: true,
            selected: fluxNumbers[5] || fluxNumbers[5] === false,
          }"
        />
        <path
          id="6"
          d="M321.461 1019.05H322.086V1025.18H321.461C317.633 1025.18 314.43 1025.8 311.852 1027.05C309.273 1028.28 307.229 1029.93 305.719 1032.02C304.208 1034.07 303.115 1036.39 302.438 1038.97C301.786 1041.55 301.461 1044.16 301.461 1046.82V1055.18C301.461 1057.71 301.76 1059.95 302.359 1061.9C302.958 1063.83 303.779 1065.45 304.82 1066.78C305.862 1068.11 307.034 1069.11 308.336 1069.79C309.664 1070.47 311.044 1070.8 312.477 1070.8C314.143 1070.8 315.628 1070.49 316.93 1069.87C318.232 1069.22 319.326 1068.32 320.211 1067.17C321.122 1066 321.812 1064.62 322.281 1063.03C322.75 1061.44 322.984 1059.7 322.984 1057.8C322.984 1056.1 322.776 1054.48 322.359 1052.91C321.943 1051.33 321.305 1049.92 320.445 1048.7C319.586 1047.45 318.505 1046.47 317.203 1045.77C315.927 1045.04 314.404 1044.67 312.633 1044.67C310.628 1044.67 308.753 1045.17 307.008 1046.16C305.289 1047.12 303.87 1048.4 302.75 1049.98C301.656 1051.55 301.031 1053.25 300.875 1055.1L297.047 1055.06C297.411 1052.15 298.089 1049.66 299.078 1047.6C300.094 1045.52 301.344 1043.83 302.828 1042.52C304.339 1041.2 306.018 1040.23 307.867 1039.63C309.742 1039.01 311.721 1038.7 313.805 1038.7C316.643 1038.7 319.091 1039.23 321.148 1040.3C323.206 1041.36 324.898 1042.8 326.227 1044.59C327.555 1046.36 328.531 1048.37 329.156 1050.61C329.807 1052.82 330.133 1055.1 330.133 1057.45C330.133 1060.13 329.755 1062.64 329 1064.98C328.245 1067.33 327.112 1069.39 325.602 1071.16C324.117 1072.93 322.281 1074.31 320.094 1075.3C317.906 1076.29 315.367 1076.78 312.477 1076.78C309.404 1076.78 306.721 1076.16 304.43 1074.91C302.138 1073.63 300.237 1071.94 298.727 1069.83C297.216 1067.72 296.083 1065.38 295.328 1062.8C294.573 1060.22 294.195 1057.6 294.195 1054.95V1051.55C294.195 1047.54 294.599 1043.6 295.406 1039.75C296.214 1035.9 297.607 1032.41 299.586 1029.28C301.591 1026.16 304.365 1023.67 307.906 1021.82C311.448 1019.97 315.966 1019.05 321.461 1019.05Z"
          :class="{
            line: true,
            selected: fluxNumbers[6] || fluxNumbers[6] === false,
          }"
        />
        <path
          id="7"
          d="M632.484 1019.12V1023.19L608.93 1076H601.312L624.828 1025.06H594.047V1019.12H632.484Z"
          :class="{
            line: true,
            selected: fluxNumbers[7] || fluxNumbers[7] === false,
          }"
        />
        <path
          id="8"
          d="M629.586 1360.61C629.586 1364.07 628.779 1367.02 627.164 1369.44C625.576 1371.83 623.414 1373.66 620.68 1374.91C617.971 1376.16 614.911 1376.78 611.5 1376.78C608.089 1376.78 605.016 1376.16 602.281 1374.91C599.547 1373.66 597.385 1371.83 595.797 1369.44C594.208 1367.02 593.414 1364.07 593.414 1360.61C593.414 1358.34 593.844 1356.27 594.703 1354.4C595.589 1352.5 596.826 1350.84 598.414 1349.44C600.029 1348.03 601.93 1346.95 604.117 1346.2C606.331 1345.41 608.766 1345.02 611.422 1345.02C614.911 1345.02 618.023 1345.7 620.758 1347.05C623.492 1348.38 625.641 1350.22 627.203 1352.56C628.792 1354.91 629.586 1357.59 629.586 1360.61ZM622.32 1360.45C622.32 1358.34 621.865 1356.48 620.953 1354.87C620.042 1353.23 618.766 1351.95 617.125 1351.04C615.484 1350.13 613.583 1349.67 611.422 1349.67C609.208 1349.67 607.294 1350.13 605.68 1351.04C604.091 1351.95 602.854 1353.23 601.969 1354.87C601.083 1356.48 600.641 1358.34 600.641 1360.45C600.641 1362.64 601.07 1364.52 601.93 1366.08C602.815 1367.61 604.065 1368.8 605.68 1369.63C607.32 1370.44 609.26 1370.84 611.5 1370.84C613.74 1370.84 615.667 1370.44 617.281 1369.63C618.896 1368.8 620.133 1367.61 620.992 1366.08C621.878 1364.52 622.32 1362.64 622.32 1360.45ZM628.258 1333.93C628.258 1336.69 627.529 1339.18 626.07 1341.39C624.612 1343.6 622.62 1345.35 620.094 1346.62C617.568 1347.9 614.703 1348.54 611.5 1348.54C608.245 1348.54 605.341 1347.9 602.789 1346.62C600.263 1345.35 598.284 1343.6 596.852 1341.39C595.419 1339.18 594.703 1336.69 594.703 1333.93C594.703 1330.62 595.419 1327.81 596.852 1325.49C598.31 1323.17 600.302 1321.4 602.828 1320.18C605.354 1318.96 608.232 1318.34 611.461 1318.34C614.716 1318.34 617.607 1318.96 620.133 1320.18C622.659 1321.4 624.638 1323.17 626.07 1325.49C627.529 1327.81 628.258 1330.62 628.258 1333.93ZM621.031 1334.05C621.031 1332.15 620.628 1330.47 619.82 1329.01C619.013 1327.55 617.893 1326.4 616.461 1325.57C615.029 1324.71 613.362 1324.28 611.461 1324.28C609.56 1324.28 607.893 1324.68 606.461 1325.49C605.055 1326.27 603.948 1327.39 603.141 1328.85C602.359 1330.31 601.969 1332.04 601.969 1334.05C601.969 1336 602.359 1337.71 603.141 1339.16C603.948 1340.62 605.068 1341.76 606.5 1342.56C607.932 1343.37 609.599 1343.77 611.5 1343.77C613.401 1343.77 615.055 1343.37 616.461 1342.56C617.893 1341.76 619.013 1340.62 619.82 1339.16C620.628 1337.71 621.031 1336 621.031 1334.05Z"
          :class="{
            line: true,
            selected: fluxNumbers[8] || fluxNumbers[8] === false,
          }"
        />
        <path
          id="9"
          d="M902.914 469.945H903.656C907.823 469.945 911.208 469.359 913.812 468.188C916.417 467.016 918.422 465.44 919.828 463.461C921.234 461.482 922.198 459.255 922.719 456.781C923.24 454.281 923.5 451.716 923.5 449.086V440.375C923.5 437.797 923.201 435.505 922.602 433.5C922.029 431.495 921.221 429.815 920.18 428.461C919.164 427.107 918.005 426.078 916.703 425.375C915.401 424.672 914.021 424.32 912.562 424.32C910.896 424.32 909.398 424.659 908.07 425.336C906.768 425.987 905.661 426.911 904.75 428.109C903.865 429.307 903.188 430.714 902.719 432.328C902.25 433.943 902.016 435.701 902.016 437.602C902.016 439.294 902.224 440.935 902.641 442.523C903.057 444.112 903.695 445.544 904.555 446.82C905.414 448.096 906.482 449.112 907.758 449.867C909.06 450.596 910.583 450.961 912.328 450.961C913.943 450.961 915.453 450.648 916.859 450.023C918.292 449.372 919.555 448.5 920.648 447.406C921.768 446.286 922.654 445.023 923.305 443.617C923.982 442.211 924.372 440.74 924.477 439.203H927.914C927.914 441.365 927.484 443.5 926.625 445.609C925.792 447.693 924.62 449.594 923.109 451.312C921.599 453.031 919.828 454.411 917.797 455.453C915.766 456.469 913.552 456.977 911.156 456.977C908.344 456.977 905.909 456.43 903.852 455.336C901.794 454.242 900.102 452.784 898.773 450.961C897.471 449.138 896.495 447.107 895.844 444.867C895.219 442.602 894.906 440.31 894.906 437.992C894.906 435.284 895.284 432.745 896.039 430.375C896.794 428.005 897.914 425.922 899.398 424.125C900.883 422.302 902.719 420.883 904.906 419.867C907.12 418.852 909.672 418.344 912.562 418.344C915.818 418.344 918.591 418.995 920.883 420.297C923.174 421.599 925.036 423.344 926.469 425.531C927.927 427.719 928.995 430.18 929.672 432.914C930.349 435.648 930.688 438.461 930.688 441.352V443.969C930.688 446.911 930.492 449.906 930.102 452.953C929.737 455.974 929.021 458.865 927.953 461.625C926.911 464.385 925.388 466.859 923.383 469.047C921.378 471.208 918.76 472.927 915.531 474.203C912.328 475.453 908.37 476.078 903.656 476.078H902.914V469.945Z"
          :class="{
            line: true,
            selected: fluxNumbers[9] || fluxNumbers[9] === false,
          }"
        />
        <path
          id="10"
          d="M744.977 718.812V776H737.75V727.836L723.18 733.148V726.625L743.844 718.812H744.977ZM801.93 743.031V751.703C801.93 756.365 801.513 760.297 800.68 763.5C799.846 766.703 798.648 769.281 797.086 771.234C795.523 773.188 793.635 774.607 791.422 775.492C789.234 776.352 786.76 776.781 784 776.781C781.812 776.781 779.794 776.508 777.945 775.961C776.096 775.414 774.43 774.542 772.945 773.344C771.487 772.12 770.237 770.531 769.195 768.578C768.154 766.625 767.359 764.255 766.812 761.469C766.266 758.682 765.992 755.427 765.992 751.703V743.031C765.992 738.37 766.409 734.464 767.242 731.312C768.102 728.161 769.312 725.635 770.875 723.734C772.438 721.807 774.312 720.427 776.5 719.594C778.714 718.76 781.188 718.344 783.922 718.344C786.135 718.344 788.167 718.617 790.016 719.164C791.891 719.685 793.557 720.531 795.016 721.703C796.474 722.849 797.711 724.385 798.727 726.312C799.768 728.214 800.562 730.544 801.109 733.305C801.656 736.065 801.93 739.307 801.93 743.031ZM794.664 752.875V741.82C794.664 739.268 794.508 737.029 794.195 735.102C793.909 733.148 793.479 731.482 792.906 730.102C792.333 728.721 791.604 727.602 790.719 726.742C789.859 725.883 788.857 725.258 787.711 724.867C786.591 724.451 785.328 724.242 783.922 724.242C782.203 724.242 780.68 724.568 779.352 725.219C778.023 725.844 776.904 726.846 775.992 728.227C775.107 729.607 774.43 731.417 773.961 733.656C773.492 735.896 773.258 738.617 773.258 741.82V752.875C773.258 755.427 773.401 757.68 773.688 759.633C774 761.586 774.456 763.279 775.055 764.711C775.654 766.117 776.383 767.276 777.242 768.188C778.102 769.099 779.091 769.776 780.211 770.219C781.357 770.635 782.62 770.844 784 770.844C785.771 770.844 787.32 770.505 788.648 769.828C789.977 769.151 791.083 768.096 791.969 766.664C792.88 765.206 793.557 763.344 794 761.078C794.443 758.786 794.664 756.052 794.664 752.875Z"
          :class="{
            line: true,
            selected: fluxNumbers[10] || fluxNumbers[10] === false,
          }"
        />
        <path
          id="11"
          d="M1047.98 718.812V776H1040.75V727.836L1026.18 733.148V726.625L1046.84 718.812H1047.98ZM1092.98 718.812V776H1085.75V727.836L1071.18 733.148V726.625L1091.84 718.812H1092.98Z"
          :class="{
            line: true,
            selected: fluxNumbers[11] || fluxNumbers[11] === false,
          }"
        />
        <path
          id="2"
          d="M932.992 173.062V179H895.766V173.805L914.398 153.062C916.69 150.51 918.461 148.349 919.711 146.578C920.987 144.781 921.872 143.18 922.367 141.773C922.888 140.341 923.148 138.883 923.148 137.398C923.148 135.523 922.758 133.831 921.977 132.32C921.221 130.784 920.102 129.56 918.617 128.648C917.133 127.737 915.336 127.281 913.227 127.281C910.701 127.281 908.591 127.776 906.898 128.766C905.232 129.729 903.982 131.083 903.148 132.828C902.315 134.573 901.898 136.578 901.898 138.844H894.672C894.672 135.641 895.375 132.711 896.781 130.055C898.188 127.398 900.271 125.289 903.031 123.727C905.792 122.138 909.19 121.344 913.227 121.344C916.82 121.344 919.893 121.982 922.445 123.258C924.997 124.508 926.951 126.279 928.305 128.57C929.685 130.836 930.375 133.492 930.375 136.539C930.375 138.206 930.089 139.898 929.516 141.617C928.969 143.31 928.201 145.003 927.211 146.695C926.247 148.388 925.115 150.055 923.812 151.695C922.536 153.336 921.169 154.951 919.711 156.539L904.477 173.062H932.992Z"
          :class="{
            line: true,
            selected: fluxNumbers[2] || fluxNumbers[2] === false,
          }"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CsuDiagnosisFluxGraph',
  props: {
    fluxNumbers: {},
  },
  data() {
    return {}
  },
}
</script>
<style scoped>
.svgContaines {
  padding: 20px;
}

rect.true,
rect.SIM {
  fill: var(--v-primary-base);
}
rect.false,
rect.NAO,
rect.NEM_SEMPRE {
  fill: var(--v-warning-base);
}
path.line.selected {
  stroke: black;
  fill: black;
}

path.lineStroke.selected {
  stroke: black;
}
</style>
